import styled from 'styled-components'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles'

interface CardUseCasesProps {
  withBackground?: boolean
  colorScheme?: string
  parentColorScheme?: string
}

export const CardUseCasesImage = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.rem(8)};
  aspect-ratio: 6 / 7;
  position: relative;
  cursor: none;

  img {
    object-fit: cover;
    object-position: center;
  }
`

export const CardUseCasesTag = styled.div<CardUseCasesProps>`
  position: absolute;
  bottom: ${({ theme }) => theme.rem(20)};
  left: ${({ theme }) => theme.rem(20)};
  z-index: 10;
`

export const CardUseCasesBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease-in-out;
`

export const CardUseCases = styled.a<CardUseCasesProps>`
  text-decoration: none;
  width: 100%;
  
  ${({ theme }) => theme.mediaQuery.lg(`
    &:hover {
      ${CardUseCasesBackdrop} {
        opacity: .3;
      }
    }
  `)}

  > ${Paragraph},
  > ${Heading} {
    color: ${({ theme, withBackground, parentColorScheme }) => withBackground ? theme.colorScheme[`${parentColorScheme}`].surface.text.base.negative : 'black'}!important;
  }
`